<template>
  <view class="checkbox-disabled-demo">
    <view-desc>禁用选项</view-desc>
    <view class="cube-checkbox-example">
      <cube-checkbox  option="{{ option }}" shape="square">Disabled</cube-checkbox>
    </view>

    <view-desc>禁用选项</view-desc>
    <view class="cube-checkbox-example">
      <cube-checkbox  option="{{ option }}">Disabled</cube-checkbox>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  options: {
    styleIsolation: 'shared'
  },
  data: {
    option: {
      disabled: true
    }
  }
})
</script>

<style lang="stylus">
.cube-checkbox-example
  padding 5px 10px
  background-color #fff
.desc
  margin-top 15px
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "usingComponents": {
      "view-desc": "../../components/desc/index",
      "cube-checkbox": "@mpxjs/mpx-cube-ui/src/components/checkbox/index"
    }
  }
</script>
